<template>
  <v-row justify="center">
    <v-dialog
        v-model="dialog"
        :persistent="true"
        width="60%"
        height="100%"
        class="modalDialog"
        no-click-animation
    >
      <v-card class="cardWrap">
        <CardTitle :title="page_title" />
        <v-row justify="start" class="titleMaxWidth">
            <div class="cardWrap__fromArea__title">氏名</div>
            <v-text-field class="px-3" v-model="full_name" disabled />
        </v-row>
        <v-data-table
            class="modalDataTable customClass"
            :items="desserts"
            :headers="headers"
            hide-default-footer
        >
            <template v-slot:[`item.member_class`]="{ item }">
                <v-radio-group
                    v-model="item.member_class"
                    row
                    readonly
                    class="customClass">
                    <v-radio
                        v-for="i in reverseItems"
                        :key="i.id"
                        :label="i.code_name"
                        :value="i.code"
                    />
                </v-radio-group>
            </template>
            <template v-slot:[`item.Btn`]="{ item }">
                <v-btn
                    class="editBtn"
                    text
                    :disabled="btn[1].isActive"
                    @click="editModalDisplayOn(item)">変更</v-btn>
                <v-btn
                    class="deleteBtn"
                    text
                    :disabled="btn[2].isActive"
                    @click="removeOverlayStart(item)">削除</v-btn>
            </template>
        </v-data-table>
        <v-pagination
            class="my-2"
            v-model="page"
            :length="pageCount"
            :total-visible="7"
            @input="clickPagination"
        />
        <v-spacer></v-spacer>
        <v-card-actions>
        <v-spacer></v-spacer>
            <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
            <v-btn color="blue  darken-4" text @click="addModalDisplayOn" :disabled="btn[0].isActive">追加</v-btn>
        </v-card-actions>
        <RemoveOverlay
            page-name="会員区分"
            @processing="deleteMemberClass"
            @cancel="removeOverlay = !removeOverlay"
            :dblclickStop="processing"
            :process-result="process"
            :OverlaySwitch="removeOverlay"
        />
        <MemberClassModal
            ref="Modal"
            :editInfo="Info"
            :name="full_name"
            :MemNo="member_no"
            @refresh-event="getMemberClassList"
            :golf_courses="golfCourseSelection"
            :golf_code="golfCourseInput"
        />
        </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import {
    DELETE_MEMBER_CLASS,
    GET_MEMBER_CLASS_LIST
} from '@/constants/member_class';
import { ListPageMixin } from '@/views/Member/ListPageMixin.js';
import RemoveOverlay from '@/views/Master/page/overlay/RemoveOverlay';
import MemberClassModal from './dialog/MemberClassModal';
import { authorityMixin } from '@/views/authorityMixin';
import { GET_CODE_LIST } from '@/constants/codelist';

export default {
    components: {
        CardTitle,
        RemoveOverlay,
        MemberClassModal
    },
    mixins: [ListPageMixin, authorityMixin],
    props: [
        'golfCourseSelection',
        'golfCourseInput'
    ],
    data () {
        return {
            page_title: '会員区分参照',
            memberClasses: [],
            headers: [
                { text: 'ゴルフ場', align: 'center', value: 'golf_name', sortable: false },
                { text: '', align: 'center', value: 'member_class', sortable: false },
                { text: '', align: 'center', value: 'Btn', sortable: false }
            ],
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '追加', isActive: true },
                { element_id: '002', element_name: '変更', isActive: true },
                { element_id: '003', element_name: '削除', isActive: true }
            ],
            vue_id: 'SCR0005'
        };
    },
    created () {
        this.getCodeList();
    },
    computed: {
        reverseItems () {
            return this.memberClasses.slice().reverse();
        }
    },
    methods: {
        async getMemberClassList () {
            let res = await this.$apollo
                .mutate({
                    fetchPolicy: 'no-cache',
                    mutation: GET_MEMBER_CLASS_LIST,
                    variables: {
                        member_no: this.member_no,
                        limit_rows: this.limit_rows,
                        begin_row: this.begin_row
                    }
                });
            const count = res.data.getMemberClassList.count;
            this.pageCount = Math.ceil(count / 5);
            this.desserts = res.data.getMemberClassList.MemberClassList;
        },
        deleteMemberClass () {
            // 二重送信防止処理
            if (this.processing) return;
            this.processing = true;

            this.$apollo.mutate({
                mutation: DELETE_MEMBER_CLASS,
                variables: { id: this.id }
            }).then(res => {
                this.process.result = res.data;
                this.removeOverlay = !this.removeOverlay;
                this.processing = false;
                this.getMemberClassList().catch(e => { this.error = e; });
            }).catch(error => {
                this.process.result = 0;
                this.process.resultText = this.$t('result.error.remove');
                this.error = error;
                this.processing = false;
            });
        },
        /** ----------------------------------------------
        * モーダル表示処理 親コンポーネントで使用
        * ---------------------------------------------- */
        ModalControl (val, item) {
            this.member_no = item.member_no;
            this.full_name = item.name;
            this.getAuthority();
            this.getMemberClassList().catch(e => { this.error = e; });
            this.dialog = val;
        },
        /** ----------------------------------------------
         * 入力欄のモーダルを登録状態で表示
         * ---------------------------------------------- */
        addModalDisplayOn () {
            this.$refs.Modal.addModal();
        },
        /** ----------------------------------------------
         * 入力欄のモーダルを編集状態で表示
         * ---------------------------------------------- */
        editModalDisplayOn (item) {
            this.Info = this.desserts.find(el => el.id === item.id);
            this.$refs.Modal.editModal();
        },
        /** ----------------------------------------------
        * モーダル非表示処理
        * ---------------------------------------------- */
        clickPagination: function () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.getMemberClassList();
        },
        getCodeList () {
            this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_CODE_LIST,
                variables: {
                    code_key: 'member_class',
                    default_display: 0
                }
            }).then(res => {
                const data = res.data.GetCodeList.CodeList;
                this.memberClasses.push(...data);
            });
        }
    }
};
</script>

<style scoped>
.cardWrap{
    margin: 0;
    padding: 20px 15px 15px;
    /* height: 500px; */
}

.v-data-table{
    height:300px;
}

.v-card{
    box-shadow: none;
}

.customClass ::v-deep .customBtn{
    display: inline-block;
    flex-direction: row;
}

.customClass ::v-deep i{
    font-size: 15px;
}

.customClass ::v-deep .v-input__slot{
    margin: 10px 0 0;
}

.customClass ::v-deep .v-input--selection-controls{
    padding-top: 0;
    margin-top: 0;
}

.titleMaxWidth{
    max-width: 60%;
}

.customClass ::v-deep label{
    font-size: 15px;
}

.editBtn{
  color: #1B5E20;
  background: Transparent;
  text-decoration: underline;
}

.deleteBtn {
  color: #d63200;
  background: Transparent;
  text-decoration: underline;
}

</style>
